/**
 * @FileDescription: 公共组件全局变量
 * @Author: zhuangjinshan
 * @Date: 2025-09-17
 * @LastEditors: zhuangjinshan
 * @LastEditTime: 2025-09-17
 */
export default {
  state: {
    cloudRegisterPopup: false,
    workOrderPopup: false,
    loginPopup: false,
    loginCallback: null,
  },
  getters: {
  },
  mutations: {
    SET_CLOUD_REGISTER_POPUP(state, payload) {
      state.cloudRegisterPopup = payload;
    },
    SET_WORK_ORDER_POPUP(state, payload) {
      state.workOrderPopup = payload;
    },
    SET_LOGIN_POPUP(state, payload) {
      state.loginPopup = payload;
    },
    SET_LOGIN_CALLBACK(state, payload) {
      state.loginCallback = payload;
    }
  },
  actions: {
    setCloudRegisterPopup(context, payload) {
      context.commit('SET_CLOUD_REGISTER_POPUP', payload);
    },
    setWorkOrderPopup(context, payload) {
      context.commit('SET_WORK_ORDER_POPUP', payload);
    },
    setLoginPopup(context, payload) {
      context.commit('SET_LOGIN_POPUP', payload);
    },
    setLoginCallback(context, payload) {
      context.commit('SET_LOGIN_CALLBACK', payload);
    }
  }
}
